import * as S from './styles';

interface MainCallToActionProps {
  as?: 'header' | 'section';
}

export const MainCallToAction: React.FC<
  React.PropsWithChildren<MainCallToActionProps>
> = ({ children, as }) => (
  <S.MainCallToAction as={as as React.ElementType}>
    {children}
  </S.MainCallToAction>
);
